import "./StyleButtonHint.css"

function ButtonHint({ className, text, id, funck, isDisabled }) {

    return (
        <>
            <button disabled={isDisabled}
                    type="button"
                    className={`button--hint__red ${className}`}
                    id={id}
                    onClick={funck}
            >
                {text}
            </button>
        </>
    )
}
export default ButtonHint
